import { Injectable } from '@angular/core';
import {PollingService} from "../../../../core/services/polling.service";

@Injectable({
  providedIn: 'root'
})
export class ChatsPollingService extends PollingService {}
